import React from "react";

export default function GuidanceImage({ src, alt }) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="mt-4 w-full max-h-56 object-contain "
    />
  );
}
